import { render, staticRenderFns } from "./data-upload-dialog.vue?vue&type=template&id=361c0b83&scoped=true&"
import script from "./data-upload-dialog.vue?vue&type=script&lang=js&"
export * from "./data-upload-dialog.vue?vue&type=script&lang=js&"
import style0 from "./data-upload-dialog.vue?vue&type=style&index=0&id=361c0b83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361c0b83",
  null
  
)

export default component.exports